import {
  Middleware,
  RequestContext,
  ResponseContext,
} from '../../../generated/api';

export default class LoggingMiddleware implements Middleware {
  constructor(
    private readonly options?: {
      requestLoggingEnabled?: boolean;
      responseLoggingEnabled?: boolean;
      logErrorResponseOnly?: boolean;
    },
  ) {}

  async pre(request: RequestContext) {
    if (this.options?.requestLoggingEnabled) {
      console.log(
        'Request:',
        JSON.stringify(
          {
            url: request.url,
            ...request.init,
          },
          null,
          2,
        ),
      );
    }
  }

  async post(context: ResponseContext) {
    if (!this.options?.responseLoggingEnabled) {
      return;
    }

    const response = context.response.clone();

    if (
      this.options.logErrorResponseOnly &&
      (context.response.status < 200 || context.response.status >= 300)
    ) {
      const text = await response.text();
      console.log('Error request: ', context.url, context.init?.headers);
      try {
        const json = JSON.parse(text);
        console.log('Error response:', JSON.stringify(json, null, 2));
      } catch {
        console.log('Error response:', text);
      }
    } else {
      try {
        console.log(
          'Response:',
          JSON.stringify(
            {
              url: context.response.url,
              status: context.response.status,
              statusText: context.response.statusText,
              response: await response.json(),
            },
            null,
            2,
          ),
        );
      } catch {
        console.log(
          {
            url: context.response.url,
            status: context.response.status,
            statusText: context.response.statusText,
            responseText: await response.text(),
          },
          null,
          2,
        );
      }
    }
  }
}
